import { format, parseISO } from "date-fns";
import HttpMethods from "@/enums/HttpMethods.js";

export default {
  data() {
    return {
      rule: {
        required: [(v) => !!v || this.$t("defaults.rules.required")],
      },
    };
  },
  methods: {
    allowOnlyNumbers: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    formatDate(date, formatType = "dd.MM.yyyy") {
      if (!date) return;
      return format(parseISO(date), formatType);
    },
    isEqualObjects(source, target) {
      const sourceKeys = Object.keys(source);
      const targetKeys = Object.keys(target);

      if (sourceKeys.length !== targetKeys.length) {
        return false;
      }

      for (let key of sourceKeys) {
        if (source[key] instanceof Array || target[key] instanceof Array) {
          return this.isEqualArray(source[key], target[key]);
        } else if (source[key] != target[key]) {
          return false;
        }
      }

      return true;
    },
    isEqualArray(arr1, arr2) {
      let N = arr1.length;
      let M = arr2.length;

      if (N != M) return false;

      arr1.sort();
      arr2.sort();

      for (let i = 0; i < N; i++) if (arr1[i] != arr2[i]) return false;

      return true;
    },
    isObjectEmpty(obj) {
      if (!obj) return true;
      return (
        Object.keys(obj).filter((key) => !!obj[key]).length === 0 &&
        obj.constructor === Object
      );
    },
    fillEmptyData(val) {
      return val || val == 0 ? val : "—";
    },
    getChangedFormItemsCount(form, initialForm) {
      let count = 0;
      for (const [key] of Object.entries(initialForm)) {
        if (form[key] && initialForm[key] != form[key]) {
          count++;
        }
      }
      return count;
    },
    getMethodColor(method) {
      switch (method) {
        case HttpMethods.GET:
          return "info";
        case HttpMethods.POST:
          return "success";
        case HttpMethods.PUT:
          return "warning";
        case HttpMethods.PATCH:
          return "warning";
        case HttpMethods.DELETE:
          return "error";
        default:
          return "info";
      }
    },
  },
};
